export default __webpack_public_path__ + "static/media/162463678_108682654639590_8839739053850919787_n.ab91ab0d.jpg";